import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import {
  ACTION,
  DEFAULT_REMESH_SETTINGS,
  PROVIDER,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Meshy mesh-simplification-pro run.
 * Produces remeshSettings (polygonType + targetPolycount from the run, default
 * faceLevel) and opens the viewer sidebar on the REMESH tab.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseMeshyMeshSimplificationProData = (openedModel) => {
  const {
    id: sessionId,
    modelFormatOutput: rawModelFormatOutput,
    generatorSessionId,
    outputAssets,
  } = openedModel
  const {
    topology: polygonType,
    targetPolycount,
  } = normalizeRunAttributes(openedModel.providerRunAttributes)
  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const enhancedProvider = PROVIDER.MESHY
  const enhancedAction = ACTION.MESH_SIMPLIFICATION
  const isSmartLowPoly = false
  const faceLevel = DEFAULT_REMESH_SETTINGS.faceLevel

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD }
  const remeshSettings = {
    isSmartLowPoly,
    faceLevel,
    targetPolycount,
    polygonType,
  }
  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.REMESH,
  }

  return {
    openedModel,
    schema,
    remeshSettings,
    ui,
    generation,
    viewer,
  }
}
